// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"34266f2c","239":"a5689070","455":"f4cfb1f8"}[chunkId] + ".chunk.js";
};